import { render } from "./AppHeader.vue?vue&type=template&id=315eabb5&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=315eabb5&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/FrontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315eabb5"]])

export default __exports__